// Mock data for HappyVan website

export const companyInfo = {
  name: "HappyVan",
  legalName: "HappyVan",
  tagline: "Moving Made Easy",
  subtitle: "We're experts in the art of moving.",
  phone: "01273 044565",
  phoneE164: "+441273044565",
  whatsapp: "441273044565",
  email: "tristan@happyvan.co",

  // --- NAP: single source of truth (schema, footer, SEO and location pages all read from here) ---
  // TODO(happyvan): confirm the full street address so schema + Google Business Profile match exactly
  streetAddress: "",
  addressLocality: "Hove",
  addressRegion: "East Sussex",
  postalCode: "BN3",
  addressCountry: "GB",
  location: "Hove, East Sussex",
  serviceArea: "Brighton, Hove & Sussex",

  // Trading history confirmed by the owner (2026-06): 5+ years. foundingYear is left null
  // until an exact start date is confirmed, so no foundingDate is claimed in schema.
  foundingYear: null,
  yearsExperience: 5,

  // Opening hours used for schema. TODO(happyvan): confirm Sunday - set "10:00-16:00" style string, or "closed".
  hours: {
    weekday: { opens: "08:00", closes: "18:00" },
    saturday: { opens: "08:00", closes: "18:00" },
    sunday: null
  },

  social: {
    facebook: "https://www.facebook.com/share/1CoU2k9gph/",
    // TODO(happyvan): confirm the live Instagram account - the site has used both
    // @happyvan2025 (footer/schema) and @happyvanbrighton (Instagram feed widget).
    // Instagram returns the same response to bots for both, so this has NOT been guessed.
    instagram: "https://www.instagram.com/happyvan2025",
    googleBusinessProfile: "https://share.google/SPoCZSS7hLHds5fIk"
  },

  logo: "https://customer-assets.emergentagent.com/job_98b7cebb-f063-4be0-8c8c-dc4674976523/artifacts/fnxdbrpa_Screenshot%202026-01-13%20at%2022.14.03.png"
};

export const services = [
  {
    id: 1,
    title: "Local & National Moving",
    description: "Whether you're moving across town or across the country, our experienced team ensures your belongings arrive safely and on time.",
    icon: "Truck",
    link: "/house-removals-brighton"
  },
  {
    id: 2,
    title: "Same Day & Urgent Delivery",
    description: "Need something moved urgently? We offer same-day bulky item collection and delivery services throughout London and the South East.",
    icon: "Clock",
    link: "/furniture-delivery-brighton"
  },
  {
    id: 3,
    title: "Secure Storage",
    description: "Short or long-term storage solutions in our secure, climate-controlled facilities. Your belongings are safe with us.",
    icon: "Warehouse",
    link: "/get-quote"
  },
  {
    id: 4,
    title: "Boxes, Packing & Unpacking",
    description: "From quality packing materials to full packing and unpacking services, we take the stress out of your move.",
    icon: "Package",
    link: "/packing-materials-brighton"
  },
  {
    id: 5,
    title: "Post-Move Cleaning",
    description: "Leave your old place spotless with our professional cleaning service. Perfect for end-of-tenancy cleans and deposit returns.",
    icon: "Sparkles",
    link: "/get-quote"
  },
  {
    id: 6,
    title: "Flat Pack Furniture Assembly",
    description: "No time or patience for flat pack? Our skilled team will assemble your furniture quickly and correctly, so you don't have to.",
    icon: "Wrench",
    link: "/get-quote"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Expert Movers",
    description: "Our trained professionals handle your belongings with care and precision.",
    icon: "Users"
  },
  {
    id: 2,
    title: "Secure Storage",
    description: "State-of-the-art facilities to keep your items safe and protected.",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Affordable Pricing",
    description: "Competitive rates with no hidden fees. Get value for your money.",
    icon: "PoundSterling"
  },
  {
    id: 4,
    title: "Google Guaranteed",
    description: "Trusted and verified by Google for your peace of mind.",
    icon: "BadgeCheck"
  }
];

export const googleReviews = [
  {
    id: 1,
    name: "Sarah M.",
    rating: 5,
    date: "2 weeks ago",
    text: "Absolutely fantastic service! The team was punctual, professional, and handled all my furniture with great care. Highly recommend HappyVan for anyone moving in Brighton.",
    avatar: "S"
  },
  {
    id: 2,
    name: "James T.",
    rating: 5,
    date: "1 month ago",
    text: "Used HappyVan for an urgent same-day delivery and they were brilliant. Quick response, fair pricing, and the driver was really helpful. Will definitely use again!",
    avatar: "J"
  },
  {
    id: 3,
    name: "Emma L.",
    rating: 5,
    date: "3 weeks ago",
    text: "Moving house is stressful but HappyVan made it so much easier. They packed everything carefully and nothing was damaged. Great communication throughout.",
    avatar: "E"
  },
  {
    id: 4,
    name: "David K.",
    rating: 5,
    date: "1 week ago",
    text: "Excellent storage service! Needed somewhere safe for my furniture while between properties. Clean facilities and reasonable prices. Very happy customer.",
    avatar: "D"
  }
];

export const moveTypes = [
  "House Move",
  "Flat Move",
  "Office Move",
  "Single Item",
  "Storage",
  "Packing Service"
];

export const floorOptions = [
  "Ground Floor",
  "1st Floor",
  "2nd Floor",
  "3rd Floor",
  "4th Floor+"
];
